import React from "react";

/**
 * Minimal, neutral brand wordmarks/marks for use in dark UI.
 * Kept as inline SVG so we don't depend on icons that may be missing from react-icons.
 */

export const BrandOracle = ({ className = "h-7 w-auto", ...rest }) => (
  <svg viewBox="0 0 120 32" className={className} fill="none" aria-label="Oracle" {...rest}>
    <g fill="currentColor">
      <path d="M16 4a12 12 0 1 0 0 24h16a12 12 0 0 0 0-24H16Zm0 4h16a8 8 0 0 1 0 16H16a8 8 0 0 1 0-16Z" />
      <text x="44" y="22" fontFamily="'Clash Display', sans-serif" fontSize="16" fontWeight="600" letterSpacing="2">
        ORACLE
      </text>
    </g>
  </svg>
);

export const BrandOracleMark = ({ className = "h-6 w-6", ...rest }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-label="Oracle" {...rest}>
    <path
      d="M11 5a11 11 0 1 0 0 22h10a11 11 0 0 0 0-22H11Zm0 4h10a7 7 0 0 1 0 14H11a7 7 0 0 1 0-14Z"
      fill="currentColor"
    />
  </svg>
);

export default BrandOracle;
